import React, {useState} from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import { EndPoints } from '../../constants/api-config';
import { MainPaymentMethods } from './main/index';

export const PaymentMethods = ({ user, loadings }) => {
    const [stripePromise] = useState(() => loadStripe(EndPoints.stripePublicKey))

    return (
        <Elements stripe={stripePromise}>
            <MainPaymentMethods user={user} loadings={loadings} />
        </Elements>
    );
};